<script lang="ts" setup>
	import { useModalStore } from '@/store/modal.store';
	import { useTeamStore } from '@/store/team.store';
	import { IUser } from '@/types';
  import {computed, ref, watch} from 'vue';
	import { useRoute } from 'vue-router';

  const props = defineProps<{
    closeSignal?: boolean
  }>();

  watch(() => props.closeSignal, () => {
    if (props.closeSignal) {
      close();
    }
  });

	const modalStore = useModalStore();
	const teamStore = useTeamStore();
	const route = useRoute();

	const groupId = computed<string>(() => String(route.params.groupId || ''));

	const newUser = ref<IUser>({
		id: '',
		name: '',
		email: '',
		group:  groupId.value,
		permissions: {}
	});

	const createUser = ():void => {
		if (groupId.value) {
			teamStore.createUser(newUser.value, 'password')
				.then(() => {
					modalStore.closeModal();
				})
		}
	};
</script>


<template>
	<div class="modal modal--active">
		<div class="modal__body">
			<div class="modal__header">
				<p class="modal__subtitle">
					<span class="material-symbols-outlined">person</span>
					<span>New User</span>
				</p>
				<button @click="modalStore.closeModal" class="modal__close">
					<span class="material-symbols-outlined">close</span>
				</button>
			</div>
			<div class="modal__main" >
				<div class="login__item">
					<input
						v-model="newUser.name"
						class="input"
						placeholder="Company Name*">

				</div>

				<button type="button" class="login__btn" @click="createUser">Continue</button>
			</div>
		</div>
	</div>
</template>